// extracted by mini-css-extract-plugin
export default {"row":"LogoAndDataLayout_row__NLB4k"};